/**
 * CMCD session header name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_SESSION = 'CMCD-Session';
//# sourceMappingURL=CMCD_SESSION.js.map